import React from "react";
import { sortByQuestionOrder } from "../../helpers/sortByQuestionOrder";

import { Grid } from "../../UI/Grid";

import { SelectQuestion } from "./SelectQuestion";
import { ISelectQuestion } from "../../constants/types";

interface IProps {
  questions?: ISelectQuestion[];
}

export const UserSelectQuestions: React.FC<IProps> = (props) => (
  <Grid container>
    {sortByQuestionOrder(props.questions as ISelectQuestion[]).map((question: any) => (
      <Grid
        item
        px={3}
        xs={12}
        key={question.questionId}
        sx={{ borderBottom: (theme) => `1px solid ${theme.palette.divider}` }}
      >
        <SelectQuestion {...question} />
      </Grid>
    ))}
  </Grid>
);

UserSelectQuestions.defaultProps = {
  questions: [],
};
